import _ from 'lodash';
import RtcClient from './RtcClient';
var RtcSubscriber = /** @class */ (function () {
    function RtcSubscriber() {
        this.subscriptions = [];
        this.hasSubscribedRtcClient = false;
    }
    Object.defineProperty(RtcSubscriber.prototype, "rtcClient", {
        get: function () {
            return RtcClient.instance;
        },
        enumerable: false,
        configurable: true
    });
    // #region public methods
    RtcSubscriber.prototype.subscribe = function (callback) {
        if (!this.hasSubscribedRtcClient) {
            this.rtcClient.register(this.rtcEvent, this.handleOn.bind(this));
            this.hasSubscribedRtcClient = true;
        }
        this.subscriptions.push(callback);
    };
    RtcSubscriber.prototype.unsubscribe = function (callback) {
        _.remove(this.subscriptions, callback);
    };
    RtcSubscriber.prototype.emit = function (data) {
        if (!data) {
            this.rtcClient.emit(this.rtcEvent);
            return;
        }
        // convert data object to DTO
        var dto = this.serializeDataObject(data);
        this.rtcClient.emit(this.rtcEvent, dto);
    };
    // #endregion
    // #region private methods
    RtcSubscriber.prototype.handleOn = function (data) {
        // convert DTO to data object
        var dataObject = this.serializeDto(data);
        // invoke all callbacks
        this.subscriptions.forEach(function (subscription) { return subscription(dataObject); });
    };
    return RtcSubscriber;
}());
export default RtcSubscriber;
//# sourceMappingURL=RtcSubscriber.js.map